export const getPersistenceKey = (key: string | undefined): string | undefined => {
  if (typeof key !== "string" || /\s/.test(key)) {
    return undefined;
  }

  const segments = key.split(":");
  if (segments.length !== 2 || segments.includes("")) {
    return undefined;
  }

  return key;
};
